/* ============================================================
   Floretti 3.0 — artikelpagina

   Vier dingen, allemaal progressive enhancement: zonder dit
   bestand blijft het artikel gewoon leesbaar.

     1. hoofdstuknavigatie uit de H2's, met actieve sectie
     2. leesvoortgang bovenaan
     3. het FAQ-blok omgezet naar <details>-accordions
     4. stap-voor-stap <ol> herkennen en apart opmaken

   De ruimte voor de navigatie staat al in CSS gereserveerd
   (.fa-toc heeft min-height, en op desktop is het een vaste
   grid-kolom), zodat het vullen niets verschuift.
   ============================================================ */

(function () {
  'use strict';

  /* Een kop die je net hebt aangeklikt landt rond 110px: 9rem
     scroll-padding voor de sticky header plus 2rem ademruimte. De
     drempel ligt daar net onder, zodat het aangeklikte hoofdstuk
     meteen actief is in plaats van het vorige. */
  var ACTIVE_OFFSET = 150;

  function slugify(text, taken) {
    var base = text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);

    if (!base) base = 'hoofdstuk';

    var slug = base;
    var n = 2;
    while (taken[slug]) {
      slug = base + '-' + n;
      n += 1;
    }
    taken[slug] = true;
    return slug;
  }

  /* Shopify's rich text levert de koppen meestal als directe
     kinderen, maar een geplakte editorversie kan alles in één div
     zetten. Het FAQ-blok loopt langs siblings, dus we werken vanaf
     het element waar de H2's echt in hangen. */
  function headingHost(body) {
    var first = body.querySelector('h2');
    return first ? first.parentElement : body;
  }

  /* ---------- 1. Stappenlijsten ----------
     Een genummerde lijst waarvan elk item met een vetgedrukte
     stapnaam opent, is in deze artikelen altijd een instructie. */
  function markStepLists(body) {
    var lists = body.querySelectorAll(':scope > ol');

    Array.prototype.forEach.call(lists, function (list) {
      var items = list.children;
      if (items.length < 2) return;

      var allLabelled = Array.prototype.every.call(items, function (li) {
        var first = li.firstElementChild;
        return first && (first.tagName === 'STRONG' || first.tagName === 'B');
      });

      if (allLabelled) list.classList.add('fa-steps');
    });
  }

  /* ---------- 2. FAQ-accordions ----------
     Alles tussen de FAQ-kop en de volgende H2 wordt per H3
     ingepakt in <details>. Native details/summary levert het
     toetsenbord- en screenreadergedrag; we bouwen bewust geen
     eigen widget. */
  function buildFaq(body, headingNames) {
    if (!headingNames.length) return;

    var headings = body.querySelectorAll(':scope > h2');

    Array.prototype.forEach.call(headings, function (h2) {
      var label = h2.textContent.trim().toLowerCase();
      var isFaq = headingNames.some(function (name) {
        return label === name || label.indexOf(name) === 0;
      });
      if (!isFaq) return;

      // Verzamel de vraag/antwoord-paren die op deze kop volgen.
      var pairs = [];
      var node = h2.nextElementSibling;

      while (node && node.tagName !== 'H2') {
        if (node.tagName === 'H3') {
          pairs.push({ question: node, answer: [] });
        } else if (pairs.length) {
          pairs[pairs.length - 1].answer.push(node);
        }
        node = node.nextElementSibling;
      }

      if (!pairs.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'fa-faq';

      pairs.forEach(function (pair) {
        var details = document.createElement('details');
        details.className = 'fa-faq__item';

        var summary = document.createElement('summary');
        var text = document.createElement('span');
        text.textContent = pair.question.textContent.trim();
        summary.appendChild(text);

        var plus = document.createElement('span');
        plus.className = 'fa-faq__plus';
        plus.setAttribute('aria-hidden', 'true');
        summary.appendChild(plus);

        var answer = document.createElement('div');
        answer.className = 'fa-faq__body';
        pair.answer.forEach(function (el) {
          answer.appendChild(el);
        });

        details.appendChild(summary);
        details.appendChild(answer);
        wrap.appendChild(details);

        pair.question.remove();
      });

      h2.insertAdjacentElement('afterend', wrap);
    });
  }

  /* ---------- 3. Hoofdstuknavigatie ---------- */
  function buildToc(root, body) {
    var toc = root.querySelector('[data-fa-toc]');
    if (!toc) return null;

    var list = toc.querySelector('[data-fa-toc-list]');
    var current = toc.querySelector('[data-fa-toc-current]');
    var box = toc.querySelector('[data-fa-toc-box]');
    var headings = Array.prototype.slice.call(body.querySelectorAll(':scope > h2'));

    // Eén hoofdstuk is geen inhoudsopgave.
    if (!list || headings.length < 2) {
      toc.hidden = true;
      return null;
    }

    var taken = {};
    var links = [];

    headings.forEach(function (heading) {
      var text = heading.textContent.trim();

      if (!heading.id) heading.id = slugify(text, taken);
      else taken[heading.id] = true;

      // Zodat de kop ook echt focus krijgt na een sprong.
      heading.setAttribute('tabindex', '-1');

      var li = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'fa-toc__link';
      link.href = '#' + heading.id;
      link.textContent = text;

      li.appendChild(link);
      list.appendChild(li);
      links.push(link);
    });

    toc.hidden = false;

    /* Op desktop staat de lijst altijd open — daar is het een rail
       naast de tekst, geen uitklapper. Op mobiel blijft hij dicht,
       zodat je niet eerst langs zes hoofdstukken moet scrollen. Dit
       gebeurt vóór de eerste paint, dus zonder layout shift. */
    var DESKTOP = 1100;

    function syncOpen() {
      if (!box || box.tagName !== 'DETAILS') return;
      // Nooit dichtklappen wat de lezer zelf heeft opengezet.
      if (window.innerWidth >= DESKTOP) box.open = true;
    }

    syncOpen();
    window.addEventListener('resize', syncOpen, { passive: true });

    /* Anker-sprongen: het vloeiende scrollen komt van
       scroll-behavior in floretti-tokens.css. Wat de browser er
       niet bij doet is focus verplaatsen — zonder dat springt een
       toetsenbordgebruiker wel visueel mee, maar staat zijn focus
       nog in de navigatie. */
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (!target) return;

        // Op mobiel is de lijst uitklapbaar; klap hem weer dicht.
        if (box && box.tagName === 'DETAILS' && box.open && window.innerWidth < DESKTOP) {
          box.open = false;
        }

        window.setTimeout(function () {
          target.focus({ preventScroll: true });
        }, 400);
      });
    });

    function setActive() {
      var index = 0;

      for (var i = 0; i < headings.length; i += 1) {
        if (headings[i].getBoundingClientRect().top <= ACTIVE_OFFSET) index = i;
        else break;
      }

      // Voorbij het laatste hoofdstuk blijft dat hoofdstuk actief.
      links.forEach(function (link, i) {
        if (i === index) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });

      if (current) current.textContent = headings[index].textContent.trim();
    }

    if (current) current.textContent = headings[0].textContent.trim();

    return setActive;
  }

  /* ---------- 4. Leesvoortgang ---------- */
  function buildProgress(root, body) {
    var bar = root.querySelector('[data-fa-progress]');
    if (!bar) return null;

    var track = bar.parentElement;

    return function update() {
      var rect = body.getBoundingClientRect();
      var viewport = window.innerHeight;
      // Hoe ver de tekst zelf voorbij de bovenkant van het scherm is
      // geschoven, gedeeld door wat er te schuiven valt.
      var span = rect.height - viewport;
      var ratio = span > 0 ? -rect.top / span : rect.top <= 0 ? 1 : 0;

      ratio = Math.min(1, Math.max(0, ratio));
      bar.style.transform = 'scaleX(' + ratio + ')';

      /* De balk meet de artikeltekst, niet de hele pagina — daaronder
         zitten nog CTA, verwante artikelen en de footer. Zou hij daar
         vol blijven staan, dan lijkt het alsof hij vastloopt. Buiten
         het artikel verdwijnt hij dus. */
      if (track) {
        track.style.opacity = ratio > 0.001 && ratio < 0.999 ? '1' : '0';
      }
    };
  }

  function init() {
    var root = document.querySelector('[data-floretti-article]');
    if (!root) return;

    var body = root.querySelector('[data-fa-content]');
    if (!body) return;

    var faqNames = (root.getAttribute('data-faq-headings') || '')
      .split(',')
      .map(function (name) {
        return name.trim().toLowerCase();
      })
      .filter(Boolean);

    var host = headingHost(body);

    markStepLists(host);
    buildFaq(host, faqNames);

    var setActive = buildToc(root, host);
    // De voortgang meet het hele tekstblok, niet alleen de koppen.
    var setProgress = buildProgress(root, body);

    if (!setActive && !setProgress) return;

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        if (setActive) setActive();
        if (setProgress) setProgress();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
